import { onShopifySectionLoad, ready } from '../global/instantiate';
import { initChangePassword, initDisplayForgotPasswordPage, toggleForgotPassword, redirectBackAfterLogin } from '../sections/account/forgot-password';
import { initAccountMobileMenu } from '../sections/account/menu';

ready(() => {
  redirectBackAfterLogin();
  toggleForgotPassword();
  initDisplayForgotPasswordPage();
  initChangePassword();
  initAccountMobileMenu();
});

onShopifySectionLoad(() => {
  initAccountMobileMenu();
});